/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 scene.gltf --transform
Author: LostBoyz2078 (https://sketchfab.com/LostModels2025)
License: CC-BY-NC-4.0 (http://creativecommons.org/licenses/by-nc/4.0/)
Source: https://sketchfab.com/3d-models/crow-fly-f47a1a1729544846a2bce22cc6adb500
Title: Crow Fly
*/

import React, { useEffect, useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function Crow(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('./models/crow/scene-transformed.glb')
  const { actions } = useAnimations(animations, group)

  useEffect(() => {
    actions[ 'GltfAnimation 0' ].timeScale = 0.10
    actions[ 'GltfAnimation 0' ].play()
  })
  
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, 0]}>
          <group name="root">
            <group name="GLTF_SceneRootNode" rotation={[Math.PI / 2, 0, 0]}>
              <group name="GLTF_created_0">
                <primitive object={nodes.GLTF_created_0_rootJoint} />
                <skinnedMesh name="Object_7" geometry={nodes.Object_7.geometry} material={materials.M_CrowWings} skeleton={nodes.Object_7.skeleton} />
                <skinnedMesh name="Object_10" geometry={nodes.Object_10.geometry} material={materials.M_CrowBody} skeleton={nodes.Object_10.skeleton} />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('./models/crow/scene-transformed.glb')
